import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

export const getScrollHandler = (infiniteQuery) => {
    return (event) => {
        const listboxNode = event.currentTarget;

        const reachedBottom =
            listboxNode.scrollTop + listboxNode.clientHeight >=
            listboxNode.scrollHeight - 1;

        if (reachedBottom && infiniteQuery.hasNextPage && !infiniteQuery.isFetchingNextPage) {
            infiniteQuery.fetchNextPage();
        }
    };
}

export const LoadingAdornment = ({ infiniteQuery, params}) => {
    return <>
        {((infiniteQuery.fetchStatus === "fetching")) ? (
            <CircularProgress color="inherit" size={20} />
        ) : null}
        {params.InputProps.endAdornment}
    </>
}